import { Users, Award, CheckCircle2, Zap, TrendingUp, Minus } from "lucide-react"

interface AnalyticsStatsProps {
  totalStudents: number
  avgScore: number
  taskCompletion: number
  engagement: string
}

export function AnalyticsStats({ totalStudents, avgScore, taskCompletion, engagement }: AnalyticsStatsProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <div className="p-4 rounded-2xl bg-teal-50 border border-teal-100">
        <div className="flex items-center gap-2 mb-2">
          <Users className="text-[#21a193] w-5 h-5" />
          <span className="text-xs font-bold uppercase text-[#21a193] tracking-wide">Total Students</span>
        </div>
        <p className="text-3xl font-extrabold text-slate-800">{totalStudents.toLocaleString()}</p>
        <div className="flex items-center gap-1 mt-1 text-xs text-teal-600 font-medium">
          <TrendingUp className="w-4 h-4" />
          <span>+4.2% vs last term</span>
        </div>
      </div>

      <div className="p-4 rounded-2xl bg-indigo-50 border border-indigo-100">
        <div className="flex items-center gap-2 mb-2">
          <Award className="text-[#4F46E5] w-5 h-5" />
          <span className="text-xs font-bold uppercase text-[#4F46E5] tracking-wide">Avg. Score</span>
        </div>
        <p className="text-3xl font-extrabold text-slate-800">{avgScore}%</p>
        <div className="flex items-center gap-1 mt-1 text-xs text-indigo-600 font-medium">
          <TrendingUp className="w-4 h-4" />
          <span>+1.5% vs last term</span>
        </div>
      </div>

      <div className="p-4 rounded-2xl bg-blue-50 border border-blue-100">
        <div className="flex items-center gap-2 mb-2">
          <CheckCircle2 className="text-[#284e8c] w-5 h-5" />
          <span className="text-xs font-bold uppercase text-[#284e8c] tracking-wide">Task Completion</span>
        </div>
        <p className="text-3xl font-extrabold text-slate-800">{taskCompletion}%</p>
        <div className="flex items-center gap-1 mt-1 text-xs text-blue-600 font-medium">
          <Minus className="w-4 h-4" />
          <span>Stable</span>
        </div>
      </div>

      <div className="p-4 rounded-2xl bg-orange-50 border border-orange-100">
        <div className="flex items-center gap-2 mb-2">
          <Zap className="text-orange-600 w-5 h-5" />
          <span className="text-xs font-bold uppercase text-orange-600 tracking-wide">Engagement</span>
        </div>
        <p className="text-3xl font-extrabold text-slate-800">{engagement}</p>
        <div className="flex items-center gap-1 mt-1 text-xs text-orange-600 font-medium">
          <TrendingUp className="w-4 h-4" />
          <span>Active Participation</span>
        </div>
      </div>
    </div>
  )
}
